import {Component, Vue} from "vue-property-decorator";
@Component
export default class DashboardMixin extends Vue {

    private windowWidth: number = window.innerWidth;

    private onResize() {
        this.windowWidth = window.innerWidth;
    }

    protected mounted() {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }

    protected beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    }

    protected get isSmallScreen(): boolean {
        return this.windowWidth < 1700;
    }
}
